export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0020s_0000_Black-&-White-30.822b0666.png";